import { Routes } from '@angular/router';

import { MpsGuestGuard } from '../guards/mps-guest.guard';
import { MpsLoggedInGuard } from '../guards/mps-loggedin.guard';
import { mpsRouteNames } from '../mps-route-names';
import { MpsTranslateTitleResolver } from '../resolvers/mps-translate-title.resolver';

export const mpsAuthRoutes: Routes = [
  {
    path: mpsRouteNames.auth,
    children: [
      {
        path: 'login',
        loadComponent: () => import('../components/mps-login/mps-login.component').then((m) => m.MpsLoginComponent),
        canActivate: [MpsGuestGuard],
        title: MpsTranslateTitleResolver,
        data: { titleKey: 'pages.titles.login' },
      },
      {
        path: 'logout',
        loadComponent: () => import('../components/mps-logout/mps-logout.component').then((m) => m.MpsLogoutComponent),
        canActivate: [MpsLoggedInGuard],
        title: MpsTranslateTitleResolver,
        data: { titleKey: 'pages.titles.logout' },
      },
      {
        path: '',
        loadComponent: () => import('../components/mps-login/mps-login.component').then((m) => m.MpsLoginComponent),
        canActivate: [MpsGuestGuard],
        title: MpsTranslateTitleResolver,
        data: { titleKey: 'pages.titles.login' },
      },
    ],
  },
  {
    path: '',
    loadComponent: () => import('../components/mps-login/mps-login.component').then((m) => m.MpsLoginComponent),
    canActivate: [MpsGuestGuard],
    title: MpsTranslateTitleResolver,
    data: { titleKey: 'pages.titles.login' },
  },
];
